import { Link } from 'react-router-dom'

import Anchor from '@/components/ui/Anchor'
import Backdrop from '@/components/ui/Backdrop'
import Container from '@/components/ui/Container'
import Logo from '@/components/ui/Logo'
import Wordmark from '@/components/ui/Wordmark'
import { useData } from '@/hooks/useLocale'

/**
 * Links over the office splash photo, darkest behind the links and lifting
 * toward the giant wordmark at the bottom.
 */
export default function Footer() {
  const { FOOTER, SITE_TAGLINE } = useData()
  return (
    <footer className="relative overflow-hidden bg-ink text-white">
      <Backdrop
        className="object-[center_35%]"
        overlay="bg-[linear-gradient(180deg,rgba(12,26,51,.94)_0%,rgba(12,26,51,.84)_55%,rgba(12,26,51,.62)_100%)]"
      />
      <Container className="relative grid grid-cols-2 gap-x-6 gap-y-10 pt-18 sm:grid-cols-3 md:grid-cols-[minmax(0,2fr)_repeat(3,minmax(0,1fr))]">
        <div className="col-span-full flex min-w-0 flex-col gap-4 md:col-span-1">
          <Link to="/" className="flex h-12 items-center self-start">
            <Logo className="h-11" />
          </Link>
          <p className="max-w-80 text-sm/[1.6] text-[#b8c6dd]">{SITE_TAGLINE}</p>
        </div>

        {FOOTER.columns.map((column) => (
          <div key={column.title} className="flex flex-col gap-3 text-sm">
            <span className="text-[13px] text-[#8a9bb8]">{column.title}</span>
            {column.links.map((link) => (
              <Anchor
                key={link.label}
                href={link.href}
                className="text-white hover:text-sky"
              >
                {link.label}
              </Anchor>
            ))}
          </div>
        ))}
      </Container>

      <Container className="relative flex flex-wrap justify-between gap-4 pt-14 text-xs text-[#8a9bb8]">
        <span className="flex flex-wrap items-center gap-x-3 gap-y-2">
          {FOOTER.copyright}
          <span aria-hidden="true">·</span>
          <Anchor
            href={FOOTER.maker.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 hover:text-white"
          >
            {FOOTER.maker.label}
            <img
              src={FOOTER.maker.logo}
              alt={FOOTER.maker.name}
              width={420}
              height={94}
              className="h-5 w-auto"
            />
          </Anchor>
        </span>
        <span className="flex flex-wrap gap-5">
          {FOOTER.bottomLinks.map((link) => (
            <Anchor key={link.label} href={link.href} className="hover:text-white">
              {link.label}
            </Anchor>
          ))}
        </span>
      </Container>

      {/* The same size as the wordmark closing the home hero, its foot cut off by the page edge. */}
      <Wordmark
        aria-hidden="true"
        className="relative mt-14 -mb-[.2em] text-center text-white/20"
      >
        {FOOTER.wordmark}
      </Wordmark>
    </footer>
  )
}
